module.exports = __webpack_public_path__ + "media/images/checkout/challenger/breadcrumb_chevron_mobile-95d411df0af297145b3eb000b98b4be6.svg";